import React from 'react';
import LocalModal from 'components/base/local-modal';
import partyPopper from 'assets/images/party-popper.svg';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const ResetPasswordSuccessModal = (props: Props) => {
  const { isOpen, onClose } = props;

  return (
    <LocalModal isOpen={isOpen} onRequestClose={onClose}>
      <div className='max-w-[394px] mx-auto flex flex-col items-center gap-[19px]'>
        <img
          src={partyPopper}
          alt='Party popper'
          className='w-[140px] h-[140px] pt-8 pr-8 rounded-full bg-[#FFF4E5]'
        />

        <article className='flex flex-col items-center gap-3 text-center'>
          <p className='font-medium'>Password reset successful!</p>
          <p className='text-[#6F7376]'>
            Your password has been changed. Kindly login with your new details
          </p>
        </article>
      </div>
    </LocalModal>
  );
};

export default ResetPasswordSuccessModal;
